import { render, staticRenderFns } from "./CustomerW9CR.vue?vue&type=template&id=7d22cd82&scoped=true&"
import script from "./CustomerW9CR.vue?vue&type=script&lang=ts&"
export * from "./CustomerW9CR.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d22cd82",
  null
  
)

export default component.exports